import React from "react"
import { observer } from "mobx-react-lite"

import Row from "@components/ui/BaseTable/Row"
import Column from "@components/ui/BaseTable/Column"
import Table from "@components/ui/BaseTable/Table"
import Text from "@components/ui/Typography/Text"
import { Option } from "@framework/types/utils"

import EditInput from "./EditInput"

interface TimeSaveBaseSubFormProps {
  optionName: string
}

const options: Option[] = [
  { name: "searchQuery", value: "Search Query" },
  { name: "productComparison", value: "Product Comparison" },
  { name: "productRecommender", value: "Product Recommender" },
]

const TimeSaveBaseSubForm: React.FC<TimeSaveBaseSubFormProps> = observer(
  ({ optionName }) => {
    return (
      <Table hideBorder>
        {options.map((option) => {
          return (
            <Row key={option.name}>
              <Column width="50%" style={{ padding: "0px" }} align="center">
                <Text variant="h5" weight="bold">
                  {option.value}
                </Text>
              </Column>
              <Column width="50%" style={{ padding: "0px" }}>
                <EditInput
                  defaultValue="0"
                  optionName={`${optionName}.${option.name}`}
                  unit="minutes"
                />
              </Column>
            </Row>
          )
        })}
      </Table>
    )
  }
)

export default TimeSaveBaseSubForm
